import { http } from "./api-config";
import store from "../store";

const apiConfigClient = http(process.env.VUE_APP_CONFIG_SERVICE)

export default {

    async getMasterConfigList() {
        try {
            let headers = {};
            if (store.state.variables.cashMasterConfigList) {
                headers = { "isSilentAPI": true };
            }
            store.commit('variables/setCashMasterConfigList', true)
            const res = await apiConfigClient.get('masterconfigs', { headers })
            return res.data
        }
        catch (error) {
            console.log(error.response)
        }
    },
    async getTenantConfigList() {
        try {
            let headers = {};
            if (store.state.variables.cashTenantConfigList) {
                headers = { "isSilentAPI": true };
            }
            store.commit('variables/setCashTenantConfigList', true)
            const res = await apiConfigClient.get('tenantconfigs', { headers })
            return res.data
        }
        catch (error) {
            console.log(error.response)
        }
    },
    async getUpdatedTenantConfigList() {
        try {
            const headers = { "isSilentAPI": true };
            const res = await apiConfigClient.get('tenantconfigs', { headers })
            return res.data
        }
        catch (error) {
            console.log(error.response)
        }
    },
    async getTenantConfigById(id) {
        const res = await apiConfigClient.get(`tenantconfig/${id}`)
        return res.data
    },
    async createTenantConfig(data) {
        try {
            const res = await apiConfigClient.post('tenantconfig', data)
            return res.data
        }
        catch (error) {
            console.log(error.response)
        }
    },
    async updateTenantConfig(data) {
        const res = await apiConfigClient.put('tenantconfig', data)
        return res.data
    },

    async deleteTenantConfig(id) {
        const res = await apiConfigClient.delete(`tenantconfig/${id}`)
        return res.data
    },

    async getValidateTenantConfigList(configName) {
        let filter = {}
        if (configName) {
            filter = {
                config_name: configName
            }
        }
        const res = await apiConfigClient.get('validatetenantconfig', { params: filter })
        return res.data
    },
    async updateEmailTemplate(data) {
        const res = await apiConfigClient.put('emailtemplate', data)
        return res.data
    },
    async deleteEmailTemplate(params) {
        const { template_id, template_type_id } = params
        const res = await apiConfigClient.delete(`emailtemplate/${template_id}`, {
            params: { template_type_id },
        })
        return res.data
    },
    async getDefaultEmailTemplates() {
        try {
            const res = await apiConfigClient.get('defaultemailtemplates')
            return res.data.status ? res.data.data : null
        }
        catch (error) {
            console.log(error.response)
        }
    },
    async createLandingPageWallpaper(data) {
        const res = await apiConfigClient.post('dashboard-wallpaper', data)
        return res.data.data
    },
    async deleteLandingPageWallpaper(id) {
        const res = await apiConfigClient.delete(`dashboard-wallpaper/${id}`)
        return res.data
    },
    async getWallpaperById(id) {
        const res = await apiConfigClient.get(`dashboard-wallpaper/${id}`, { responseType: "blob" })
        return res.data
    },
    async getTenantNamesHistory() {
        const res = await apiConfigClient.get(`tenantnameshistory`)
        return res.data
    },
}